module.exports = __webpack_public_path__ + "img/logo.ee0fe8fe.png";